import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminFinesApi } from "../../http/fines/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteFineDialogProps = {
  fineId: string;
  carId: string;
  onClose: (success: boolean) => void;
};

const DeleteFineDialog: FC<DeleteFineDialogProps> = ({ fineId, onClose, carId }) => {
  const i18n = useI18n();
  const finesApi = useAdminFinesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  return (
    <ModalDialog
      onClose={() => onClose(false)}
      title={i18n.t.fines.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: () => onClose(false),
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            finesApi
              .deleteAdminFine(fineId, carId)
              .then(() => onClose(true))
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.fines.questions.delete}
    </ModalDialog>
  );
};

export default DeleteFineDialog;
